// export const BEGIN_DATE = 'beginDate';
// export const END_DATE = 'endDate';
// export const FLIGHT_DATE_SEARCH = 'flightDateSearch';

export const DATE_FILTERS = {
    BEGIN_DATE: 'beginDate',
    END_DATE: 'endDate',
    FLIGHT_DATE_SEARCH: 'flightDateSearch',
    SELECTED_RANGE: 'selectedRange'
};

export const CMS_GALLERY_TYPES = {
    IMAGE: 'IMAGE',
    YOUTUBE: 'YOUTUBE'
};
